
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.faq-ques-block');
  const groups = document.querySelectorAll('.faq-answer-group');
  const searchInput = document.getElementById('search_faq');

  let activeTitle = 'All FAQS';

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      activeTitle = tab.dataset.title;

      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      groups.forEach(group => {
        group.classList.toggle(
          'is-active',
          activeTitle === 'All FAQS' || group.dataset.title === activeTitle
        );
      });

      resetAccordion();
      openFirstVisiblePanel();
      applySearchFilter(); // re-apply search after tab change
    });
  });

  // Search Logic

  searchInput.addEventListener('input', applySearchFilter);

  function applySearchFilter() {
    const query = searchInput.value.toLowerCase().trim();

    groups.forEach(group => {
      const isGroupActive =
        activeTitle === 'All FAQS' || group.dataset.title === activeTitle;

      if (!isGroupActive) {
        group.style.display = 'none';
        return;
      }

      let hasMatch = false;
      const panels = group.querySelectorAll('.pannel-tab');

      panels.forEach(panel => {
        const question = panel.querySelector('.panel-heading')?.innerText.toLowerCase() || '';
        const answer = panel.querySelector('.panel-in')?.innerText.toLowerCase() || '';

        const match = query === '' || question.includes(query) || answer.includes(query);

        panel.style.display = match ? '' : 'none';

        if (match && query !== '') {
          openPanel(panel);
          hasMatch = true;
        } else {
          closePanel(panel);
        }
      });

      group.style.display = hasMatch || query === '' ? 'block' : 'none';
    });

    if (query === '') {
      resetAccordion();
      openFirstVisiblePanel();
    }
  }


  function resetAccordion() {
    document.querySelectorAll('.panel-heading').forEach(h => h.classList.remove('open'));
    document.querySelectorAll('.panel-content').forEach(c => c.style.display = 'none');
  }

  function openFirstVisiblePanel() {
    const first = document.querySelector(
      '.faq-answer-group.is-active .pannel-tab:not([style*="display: none"]) .panel-heading'
    );
    if (first) {
      first.classList.add('open');
      first.nextElementSibling.style.display = 'block';
    }
  }

  function openPanel(panel) {
    panel.querySelector('.panel-heading').classList.add('open');
    panel.querySelector('.panel-content').style.display = 'block';
  }

  function closePanel(panel) {
    panel.querySelector('.panel-heading').classList.remove('open');
    panel.querySelector('.panel-content').style.display = 'none';
  }
});
